// @flow strict

import React from "react";
import "./TextButton.css";

function TextButton(props) {
  return (
    <span className="text-button custom-button" onClick={props.onClick} style={props.style}>
      {props.children}
    </span>
  );
}

export default TextButton;
